import React from "react";

const UnknownStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.82758 8.06896C7.82758 8.06896 8.06896 5.89655 9.99999 5.89655C11.931 5.89655 12.1724 7.10344 12.1724 8.06896C12.1724 8.79435 11.7636 9.51984 10.946 9.83576C10.4487 10.0279 9.99999 10.4323 9.99999 10.9655V11.2069",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4828 13.8621C10.4828 14.1287 10.2666 14.3449 10 14.3449C9.73342 14.3449 9.51724 14.1287 9.51724 13.8621C9.51724 13.5955 9.73342 13.3793 10 13.3793C10.2666 13.3793 10.4828 13.5955 10.4828 13.8621Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(UnknownStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;